module.exports = __webpack_public_path__ + "img/product3.1002f8d3.jpg";